import { createVNode as _createVNode, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "sidebar-wrapper" }
const _hoisted_2 = { class: "sidebar-main" }
const _hoisted_3 = {
  key: 0,
  class: "sidebar-title"
}
const _hoisted_4 = {
  key: 1,
  class: "wrapper-logo"
}
const _hoisted_5 = ["src"]
const _hoisted_6 = ["src"]
const _hoisted_7 = { class: "navigation-link-title" }
const _hoisted_8 = {
  key: 0,
  class: "navigation-link-counter"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      class: _normalizeClass(["sidebar-short-panel", { 'short-panel-hidden': !$props.isActiveBurger }])
    }, [
      _createVNode($setup["SidebarShortPanel"])
    ], 2),
    _createElementVNode("div", _hoisted_2, [
      ($setup.navTitle)
        ? (_openBlock(), _createElementBlock("div", _hoisted_3, _toDisplayString($setup.navTitle), 1))
        : (_openBlock(), _createElementBlock("div", _hoisted_4, [
            ($setup.selectedEstate)
              ? (_openBlock(), _createElementBlock("img", {
                  key: 0,
                  src: $setup.selectedEstate.logoUrl
                }, null, 8, _hoisted_5))
              : _createCommentVNode("", true)
          ])),
      _createElementVNode("nav", null, [
        _createElementVNode("ul", null, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.navigationWithAccess, (item, index) => {
            return (_openBlock(), _createElementBlock("li", { key: index }, [
              (item.canAccess)
                ? (_openBlock(), _createBlock(_component_router_link, {
                    key: 0,
                    class: _normalizeClass(["navigation-link", [$setup.getActiveRouteClass(item), { 'unactive-link ': item.soon }]]),
                    to: item.link,
                    onClick: ($event: any) => ($setup.onNavigationLink(item))
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("img", {
                        src: require(`../../assets/icons/${item.icon}`),
                        class: _normalizeClass(item.class)
                      }, null, 10, _hoisted_6),
                      _createElementVNode("div", _hoisted_7, _toDisplayString(item.title), 1),
                      (item.counter)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_8, _toDisplayString(item.counter), 1))
                        : _createCommentVNode("", true)
                    ]),
                    _: 2
                  }, 1032, ["to", "class", "onClick"]))
                : _createCommentVNode("", true)
            ]))
          }), 128))
        ])
      ])
    ])
  ]))
}